const BUILD_ID_KEY = "app_build_id";

/**
 * Vide le localStorage et le sessionStorage lorsqu'une nouvelle version de
 * l'application est détectée (build id différent de celui stocké lors de la
 * précédente visite). Utile notamment pour purger des caches tiers devenus
 * incompatibles après une mise à jour (ex: cache MSAL entre deux versions
 * majeures) sans dépendre d'une action manuelle des utilisateurs.
 *
 * Ne touche pas aux cookies : l'authentification de l'application repose sur
 * des cookies (voir js-cookie) et n'est donc pas affectée par ce nettoyage.
 */
export const clearStorageOnNewVersion = (): void => {
  const currentBuildId = import.meta.env.VITE_BUILD_ID;
  if (!currentBuildId) {
    return;
  }

  let storedBuildId: string | null = null;
  try {
    storedBuildId = localStorage.getItem(BUILD_ID_KEY);
  } catch {
    // Storage indisponible (mode privé restrictif, etc.) : on ignore.
    return;
  }

  if (storedBuildId === currentBuildId) {
    return;
  }

  try {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem(BUILD_ID_KEY, currentBuildId);
  } catch {
    // Si l'écriture échoue également, on ne bloque pas le chargement de l'app.
  }
};
